import SignInContainer from 'containers/auth/SignInContainer';
import React from 'react';

export default function SignIn() {
  return <SignInContainer />;
}
